<template>
  <div>
    <div style="position: absolute; top: 10px; left: 10px;" id="backButton">
      <font-awesome-icon @click="goRouter('/sportsengine')" class="menuIcon" icon="arrow-left" />
    </div>
    <img src="/se_logo_full.png" style="width: 300px; max-width: 90%" />

    <br />

    <div><h1 class="title is-2">Import Data</h1></div>

    <div class="importHeader">Select Site</div>

    <Dropdown
      :filter="true"
      :options="sites"
      optionLabel="name"
      optionValue="id"
      placeholder="Select Site"
      style="width: 300px"
      class="p-mb-2"
      v-model="selectedSite"
      @input="getSeasons"
    />

    <div v-if="seasons.length">
      <div class="importHeader">Select Season</div>

      <Dropdown
        :filter="true"
        :options="seasons"
        placeholder="Select Season"
        style="width: 300px"
        class="p-mb-2"
        v-model="selectedSeason"
      />
    </div>

    <div class="p-my-3">
      <div class="p-d-flex p-justify-center">
        <div class="p-field-checkbox" style="display: block; text-align: center" v-if="selectedSeason">
          <Checkbox id="binary" v-model="includeGames" :binary="true" />
          <label for="binary">Include Games</label>
        </div>
        <div class="p-field-checkbox ml-4" style="display: block; text-align: center" v-if="selectedSeason">
          <Checkbox id="binary" v-model="includePractices" :binary="true" />
          <label for="binary">Include Practices</label>
        </div>
        <div class="p-field-checkbox ml-4" style="display: block; text-align: center" v-if="selectedSeason">
          <Checkbox id="binary" v-model="includeCoaches" :binary="true" />
          <label for="binary">Include Coaches</label>
        </div>
      </div>

      <br />

      <Button v-if="!isLoading" :disabled="!selectedSeason" label="Import" class="p-button-lg" @click="doImport" />
      <div v-else>
        <ProgressSpinner />
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";

export default {
  data() {
    return {
      includeGames: false,
      includePractices: false,
      includeCoaches: false,
      sites: [],
      leagues: [],
      seasons: [],
      subseasons: [],
      isLoading: true,
      selectedSite: null,
      selectedLeague: null,
      selectedSeason: null,
      selectedSubseason: null,
    };
  },
  methods: {
    getSites() {
      api
        .getSESitesBeta()
        .then(response => {
          this.sites = response.data.sort(this.dynamicSort("name"));
          this.selectedLeague = null;
          this.selectedSeason = null;
          this.isLoading = false;
        })
        .catch(e => {
          alert(
            "Please re-connect your SportsEngine account to continue. If you do not own this Diamond Scheduler account (e.g. you are staff), DO NOT connect your SE account. Ask the account owner to login and re-connect.",
          );
          this.isLoading = false;
          this.goRouter("/sportsengine");
        });
    },
    getSeasons() {
      api
        .getSESeasonsBeta(this.selectedSite)
        .then(response => {
          this.selectedSeason = null;
          this.seasons = response.data;
          this.isLoading = false;
        })
        .catch(e => {
          console.log(e);
        });
    },
    doImport() {
      this.isLoading = true;
      api
        .importSportsEngineBeta(
          this.selectedSite,
          this.selectedSeason,
          this.includeGames,
          this.includePractices,
          this.includeCoaches,
        )
        .then(response => {
          this.isLoading = false;
          this.goRouter("/activity/" + response.data.activity.id);
        })
        .catch(e => {
          console.log(e);
          this.makeToast("error", "Could not import season");
          this.isLoading = false;
        });
    },
  },
  mounted() {
    this.getSites();
  },
};
</script>
